module.exports = __webpack_public_path__ + "images/highlight-24c8284f3d83c6f55956dd3357d597b6.png";